import { platformsDocumentation } from '../../documentation';

export const Platforms = () => {
  return (
    <>
      {platformsDocumentation.map((doc) => (
        <div id={doc.id} key={doc.id}>
          {doc.content}
        </div>
      ))}
    </>
  );
};
